import React, { useState } from 'react';
import { usePolling } from '../hooks/useApi';
import { api } from '../utils/api';

async function fetchRisk() {
  return api.getTokenRiskConfigs();
}

export function TokenRiskPage() {
  const { data: configs, refetch } = usePolling(fetchRisk, 10000);
  const [editing, setEditing] = useState<string | null>(null);
  const [form, setForm] = useState<any>({});

  async function save(token: string) {
    try {
      await api.updateTokenRiskConfig(token, form);
      setEditing(null);
      refetch();
    } catch {}
  }

  function startEdit(cfg: any) {
    setEditing(cfg.token);
    setForm({
      max_size_usd: cfg.max_size_usd,
      min_liquidity_usd: cfg.min_liquidity_usd,
      max_cex_book_impact_pct: cfg.max_cex_book_impact_pct,
      max_dex_price_impact_pct: cfg.max_dex_price_impact_pct,
      min_spread_pct: cfg.min_spread_pct,
      enabled: cfg.enabled ? 1 : 0,
    });
  }

  return (
    <div>
      <div className="section-title">Риск-лимиты по токенам</div>
      <table className="table">
        <thead>
          <tr>
            <th>Токен</th>
            <th>Макс. размер</th>
            <th>Мин. ликвидность</th>
            <th>CEX проскальз.</th>
            <th>DEX проскальз.</th>
            <th>Мин. спред</th>
            <th>Включён</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {configs?.map((cfg: any) => (
            <tr key={cfg.token}>
              {editing === cfg.token ? (
                <>
                  <td className="route-token">{cfg.token}</td>
                  <td><input type="number" value={form.max_size_usd} onChange={e => setForm({...form, max_size_usd: +e.target.value})} style={{width:60}} /></td>
                  <td><input type="number" value={form.min_liquidity_usd} onChange={e => setForm({...form, min_liquidity_usd: +e.target.value})} style={{width:60}} /></td>
                  <td><input type="number" step="0.1" value={form.max_cex_book_impact_pct} onChange={e => setForm({...form, max_cex_book_impact_pct: +e.target.value})} style={{width:60}} /></td>
                  <td><input type="number" step="0.1" value={form.max_dex_price_impact_pct} onChange={e => setForm({...form, max_dex_price_impact_pct: +e.target.value})} style={{width:60}} /></td>
                  <td><input type="number" step="0.1" value={form.min_spread_pct} onChange={e => setForm({...form, min_spread_pct: +e.target.value})} style={{width:60}} /></td>
                  <td><input type="checkbox" checked={form.enabled === 1} onChange={e => setForm({...form, enabled: e.target.checked ? 1 : 0})} /></td>
                  <td><button className="btn btn-sm btn-primary" onClick={() => save(cfg.token)}>Сохранить</button></td>
                </>
              ) : (
                <>
                  <td className="route-token">{cfg.token}</td>
                  <td className="text-mono">${cfg.max_size_usd}</td>
                  <td className="text-mono">${cfg.min_liquidity_usd}</td>
                  <td className="text-mono">{cfg.max_cex_book_impact_pct}%</td>
                  <td className="text-mono">{cfg.max_dex_price_impact_pct}%</td>
                  <td className="text-mono">{cfg.min_spread_pct}%</td>
                  <td><span className={'badge ' + (cfg.enabled ? 'badge-success' : 'badge-danger')}>{cfg.enabled ? 'ВКЛ' : 'ВЫКЛ'}</span></td>
                  <td><button className="btn btn-sm btn-outline" onClick={() => startEdit(cfg)}>Изменить</button></td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
